/**
 * PreparerNumbersCard — Paramètres → Cabinet : numéros de préparateur / transmetteur (T4 XML T619, RL-1 XML, TED, ImpôtNet). Batch #14.263.
 */
import { BadgeCheck, Save } from "lucide-react";

export const PREPARER_FIELDS = [
  "preparer_contact_name", "preparer_cra_account", "preparer_cra_rep_id", "preparer_cra_efile",
  "preparer_rq_number", "preparer_rq_certification", "preparer_rq_netfile", "preparer_rl1_next_number",
];

const FED = [
  { k: "preparer_contact_name", label: "Nom du contact (transmetteur)", ph: "Prénom Nom", hint: "Personne-ressource inscrite sur le T619 et le T4 Sommaire" },
  { k: "preparer_cra_account", label: "Compte ARC du transmetteur (BN9 ou BN15)", ph: "123456789 ou 123456789RP0001", hint: "Celui utilisé pour ouvrir une session (Mon dossier d'entreprise / code d'accès Web)" },
  { k: "preparer_cra_rep_id", label: "RepID (Représenter un client)", ph: "A123456", hint: "7 caractères — requis si vous transmettez via Représenter un client" },
  { k: "preparer_cra_efile", label: "Numéro TED (préparateur T1 / T2)", ph: "A1234", hint: "Information — déclarations de revenus" },
];
const QC = [
  { k: "preparer_rq_number", label: "Numéro de préparateur Revenu Québec", ph: "NP123456", hint: "Attribué par la Division de l'acquisition des données électroniques (edi@revenuquebec.ca)" },
  { k: "preparer_rq_certification", label: "N° de certification du logiciel (RL-1 XML)", ph: "RQ-26-01-001", hint: "Obtenu après l'envoi d'un fichier test à Revenu Québec — change chaque année" },
  { k: "preparer_rq_netfile", label: "N° de préparateur ImpôtNet Québec", ph: "", hint: "Information — déclarations TP-1" },
  { k: "preparer_rl1_next_number", label: "Prochain n° de relevé RL-1 (8 chiffres)", ph: "10000001", type: "number", hint: "Début de la plage séquentielle attribuée par RQ — s'incrémente à chaque relevé numéroté" },
];

function Col({ title, items, settings, update }) {
  return (
    <div className="space-y-3">
      <h4 className="text-xs font-bold text-slate-700 uppercase tracking-wide">{title}</h4>
      {items.map((f) => (
        <div key={f.k}>
          <label className="block text-sm font-medium mb-1">{f.label}</label>
          <input type={f.type || "text"} value={settings[f.k] ?? ""} placeholder={f.ph}
            onChange={(e) => update(f.k, f.type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm font-mono" data-testid={`settings-${f.k.replace(/_/g, "-")}`} />
          {f.hint && <p className="text-[11px] text-slate-500 mt-0.5">{f.hint}</p>}
        </div>
      ))}
    </div>
  );
}

export default function PreparerNumbersCard({ settings, update, onSave }) {
  return (
    <div className="bg-white border rounded-xl p-5 space-y-4" data-testid="preparer-section">
      <div>
        <h3 className="font-semibold text-sm flex items-center gap-2"><BadgeCheck className="w-4 h-4" /> Numéros de préparateur</h3>
        <p className="text-xs text-slate-500 mt-1">Inscrits automatiquement dans les fichiers de transmission de fin d'année (Paie → Fin d'année : XML T4 / T619 et XML RL-1) et sur les sommaires.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <Col title="Fédéral — ARC" items={FED} settings={settings} update={update} />
        <Col title="Québec — Revenu Québec" items={QC} settings={settings} update={update} />
      </div>
      <button onClick={() => onSave(PREPARER_FIELDS)}
        className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-700 flex items-center gap-2" data-testid="settings-save-preparer">
        <Save className="w-4 h-4" /> Sauvegarder les numéros
      </button>
    </div>
  );
}
